import {
  DONATION_PROJECT_DETAILS_BY_ID_LOADING,
  DONATION_PROJECT_DETAILS_BY_ID_SUCCESS,
  DONATION_PROJECT_DETAILS_BY_ID_FAILURE,
} from "redux/types";

const initialState = {
  projectDetailsLoading: false,
  projectDetails: null,
  errors: null,
};

export const donationProjectDetailsByIdReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case DONATION_PROJECT_DETAILS_BY_ID_LOADING:
      return { ...state, projectDetailsLoading: action.payload };
    case DONATION_PROJECT_DETAILS_BY_ID_SUCCESS:
      return { ...state, projectDetails: action.payload };
    case DONATION_PROJECT_DETAILS_BY_ID_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
